/** @format */

import React from 'react'
import localize from '../../Global/Localize'
import { formatDate } from '../../Helpers/formatters'
import SimpleLookup from './SimpleLookup'

const UnitOfMeasureLookup = ({ displayValue, onSelect }) => {
  const columns = [
    {
      label: localize('name'),
      template: r => <>{r.description}</>,
    },
    {
      label: localize('contains'),
      template: r => <>{r.contains}</>,
    },
    {
      label: localize('ofBaseUnits'),
      template: r => <>{r.baseUnitsDescription}</>,
    },
    {
      label: localize('createdDate'),
      template: r => <>{formatDate(r.createdDate, true)}</>,
    },
  ]
  return (
    <>
      <SimpleLookup
        title={localize('unitOfMeasureLookup')}
        url={
          '/inventoryUnitOfMeasure/find-inventory-unit-of-measure-by-filter-in-page'
        }
        params={{
          text: '',
          pageIndex: 0,
          pageSize: 10,
        }}
        columns={columns}
        displayValue={displayValue}
        onSelect={onSelect}
      />
    </>
  )
}

export default UnitOfMeasureLookup
